/* eslint-disable @typescript-eslint/no-explicit-any */
import { ActionTree, GetterTree, MutationTree } from 'vuex';
import {
    ConnectFlowSurveyState,
    ConnectFlowSurveyMutations,
    ConnectFlowSurveyActions,
    ConnectFlowSurveyGetters,
    ConnectFlowSurveyFilter,
    SortMenuItem,
    FilterItem,
} from '@/types';

const getDefaultState = () => {
    return {
        search: null,
        sort: [],
        page: 1,
        filter: {
            roles: [],
            isActive: null,
        },
    } as ConnectFlowSurveyState;
};

const state: ConnectFlowSurveyState = getDefaultState();

const mutations: MutationTree<ConnectFlowSurveyState> = {
    [ConnectFlowSurveyMutations.SET_SEARCH]: (state, search: string) => (state.search = search),
    [ConnectFlowSurveyMutations.SET_SORT]: (state, sort: SortMenuItem[]) => (state.sort = sort),
    [ConnectFlowSurveyMutations.SET_PAGE]: (state, page: number) => (state.page = page),
    [ConnectFlowSurveyMutations.SET_FILTER](state, filter: ConnectFlowSurveyFilter) {
        state.filter.isActive = filter.isActive;
    },
    [ConnectFlowSurveyMutations.CLEAR_FILTER](state, item?: FilterItem) {
        switch (item?.field) {
            case 'isActive':
                state.filter.isActive = getDefaultState().filter.isActive;
                break;
            default:
                state.filter.isActive = getDefaultState().filter.isActive;
        }
    },
};

const actions: ActionTree<ConnectFlowSurveyState, any> = {
    [ConnectFlowSurveyActions.SET_SEARCH]: ({ commit }, search: string) =>
        commit(ConnectFlowSurveyMutations.SET_SEARCH, search),
    [ConnectFlowSurveyActions.SET_SORT]: ({ commit }, sort: SortMenuItem[]) =>
        commit(ConnectFlowSurveyMutations.SET_SORT, sort),
    [ConnectFlowSurveyActions.SET_PAGE]: ({ commit }, page: number) =>
        commit(ConnectFlowSurveyMutations.SET_PAGE, page),
    [ConnectFlowSurveyActions.SET_FILTER]: ({ commit }, filter: ConnectFlowSurveyFilter) =>
        commit(ConnectFlowSurveyMutations.SET_FILTER, filter),
    [ConnectFlowSurveyActions.CLEAR_FILTER]: ({ commit }, item: FilterItem) =>
        commit(ConnectFlowSurveyMutations.CLEAR_FILTER, item),
};

const getters: GetterTree<ConnectFlowSurveyState, any> = {
    [ConnectFlowSurveyGetters.SEARCH]: (state): string | null => state.search,
    [ConnectFlowSurveyGetters.SORT]: (state): SortMenuItem[] => state.sort,
    [ConnectFlowSurveyGetters.PAGE]: (state): number => state.page,
    [ConnectFlowSurveyGetters.FILTER]: (state): ConnectFlowSurveyFilter => state.filter,
    [ConnectFlowSurveyGetters.DEFAULT_FILTER]: (): ConnectFlowSurveyFilter =>
        getDefaultState().filter,
    [ConnectFlowSurveyGetters.ACTIVE_FILTERS](state): FilterItem[] {
        const filters: Array<FilterItem> = [];

        if (state.filter.isActive !== null) {
            filters.push({
                field: 'isActive',
                value: state.filter.isActive.value,
                label: state.filter.isActive.label,
            });
        }

        return filters;
    },
};

export default {
    state,
    mutations,
    actions,
    getters,
};
